import { useSDK } from "~hooks";
import { Order } from "~graphql/sdk";
import { useEffect } from "react";
import {
  broadcastParamsFromReportingId,
  getBroadcastParamsFromQuery,
} from "~hooks/broadcastHelper";
import { useRouter } from "next/router";

const BroadcastReportingData = "BroadcastReportingData";

const getBroadcastReportingTrackingCode = () =>
  sessionStorage?.getItem(BroadcastReportingData);

const setReportingData = (id: string) =>
  sessionStorage?.setItem(BroadcastReportingData, id);

export const useCampaignReportingOpen = (trigger: boolean) => {
  const router = useRouter();
  const sdk = useSDK();
  const { query } = router;
  const {
    broadcastId,
    userId,
    waitlistUserId,
    sourceId,
    reportingId,
    transactionalType,
  } = getBroadcastParamsFromQuery(query);

  const useMembership = transactionalType === "membership";

  useEffect(() => {
    if (trigger) {
      if (broadcastId && (userId || waitlistUserId) && sourceId) {
        const doAsyncReporting = async () => {
          try {
            const trackingCode = getBroadcastReportingTrackingCode();
            if (trackingCode !== reportingId) {
              await sdk.broadcastReportingLinkOpened({
                input: {
                  broadcastId,
                  ...(useMembership
                    ? { membershipId: sourceId }
                    : { eventId: sourceId }),
                  userId,
                  waitlistUserId,
                },
              });
              setReportingData(reportingId);
            }
          } catch (error) {
            // Handle errors
            console.error("Error saving data:", error);
          }
        };

        void doAsyncReporting();
      }
    }
  }, [trigger]);
};

export const useCampaignReportingForOrder = async (order: Order) => {
  const trackingCode = getBroadcastReportingTrackingCode();
  if (!trackingCode) {
    return;
  }
  const { sourceId } = broadcastParamsFromReportingId(trackingCode);
  if (order.event?.id == sourceId) {
    const {
      broadcastId,
      userId,
      waitlistUserId,
      sourceId,
    } = broadcastParamsFromReportingId(trackingCode);

    const sdk = useSDK();
    await sdk.broadcastReportingOrderCreated({
      input: {
        broadcastId,
        eventId: sourceId,
        userId,
        waitlistUserId,
        orderId: order.id,
      },
    });
  }
};
